export function isInvalidAudioResponse(status: number, payload: unknown): boolean {
  return status === 422 && typeof payload === "object" && payload !== null &&
    "code" in payload && payload.code === "invalid_audio";
}

export function transferFailureMessage(phase: "upload" | "processing" | "download", format: string): string {
  if (phase === "download") {
    return `The connection was interrupted while receiving your result. Your selected file is still available. Try again${format === "wav" ? ", or choose MP3 for a smaller download" : ""}.`;
  }
  return "We could not connect to the audio service. Check your connection and try again. Your selected file is still available.";
}
export type AudioFailureReason = "processor_error" | "network_error" | "timeout" | "file_read_error" | "invalid_audio";

type FailureAnalytics = {
  capture(event: string, properties: Record<string, unknown>): unknown;
  captureException(error: Error, properties: Record<string, unknown>): unknown;
};

export function reportAudioFailure(analytics: FailureAnalytics, reason: AudioFailureReason, properties: Record<string, unknown>): void {
  const failureProperties = { ...properties, failure_reason: reason };
  analytics.capture("audio_processing_failed", failureProperties);
  if (reason === "invalid_audio") return;
  const error = new Error(`Audio processing failed: ${reason}`);
  error.name = "AudioProcessingError";
  analytics.captureException(error, failureProperties);
}

